import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.string.small.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import { formatImageCloudinary } from '~/helpers/image-helper';
import { EMPTY_PIXEL } from '~/const/images';
import Accordion from '~/components/molecules/Accordion';
export default {
  name: 'ProductDescription',
  components: {
    Accordion: Accordion
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      toggle: {
        description: true,
        complementary: false,
        additional: false,
        range: false
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    hasMaterialsImage: function hasMaterialsImage() {
      if (!isEmpty(this.payload.additionalInformation.additionalContent.image)) {
        var _ref, _ref2, _ref3;

        return {
          material_image: {
            image: {
              small: formatImageCloudinary((_ref3 = this.payload) != null ? (_ref3 = _ref3.additionalInformation) != null ? (_ref3 = _ref3.additionalContent) != null ? (_ref3 = _ref3.image) != null ? _ref3.small : _ref3 : _ref3 : _ref3 : _ref3, ['q_auto,f_auto', 'w_200']) || EMPTY_PIXEL,
              large: formatImageCloudinary((_ref2 = this.payload) != null ? (_ref2 = _ref2.additionalInformation) != null ? (_ref2 = _ref2.additionalContent) != null ? (_ref2 = _ref2.image) != null ? _ref2.large : _ref2 : _ref2 : _ref2 : _ref2, ['q_auto,f_auto', 'w_500']) || EMPTY_PIXEL,
              alt: ((_ref = this.payload) != null ? (_ref = _ref.additionalInformation) != null ? (_ref = _ref.additionalContent) != null ? (_ref = _ref.image) != null ? _ref.alt : _ref : _ref : _ref : _ref) || ''
            }
          }
        };
      }

      return false;
    },
    hasDescriptionMain: function hasDescriptionMain() {
      return Boolean(!isEmpty(this.payload.description.main));
    },
    hasAdditionalContent: function hasAdditionalContent() {
      return Boolean(!isEmpty(this.payload.additionalInformation.additionalContent));
    },
    hasInfoCompContent: function hasInfoCompContent() {
      return Boolean(!isEmpty(this.payload.additionalInformation.infoCompDescription));
    },
    hasProductRange: function hasProductRange() {
      return Boolean(!isEmpty(this.payload.description.line) || !isEmpty(this.payload.line));
    },
    productRangeUrl: function productRangeUrl() {
      return this.buildSearchUrl(this.locale, this.payload.line);
    }
  }),
  methods: {
    handleClick: function handleClick(event, arg) {
      var _this = this;

      this.toggle[arg] = !this.toggle[arg];
      Object.keys(this.toggle).filter(function (e) {
        return e !== arg;
      }).forEach(function (e) {
        _this.toggle[e] = false;
      });
      this.handleTracking(event, arg);
    },
    handleTracking: function handleTracking(event, arg) {
      if (arg === 'description') {
        this.$root.$emit('generic-tracking', event, {
          fn: 'track-event',
          data: {
            event_category: 'FicheProduit',
            event_action: this.toggle[arg] ? 'Clic_derouler_description' : 'Clic_reduire_description',
            event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
          }
        });
      }

      if (arg === 'complementary') {
        this.$root.$emit('generic-tracking', event, {
          fn: 'track-event',
          data: {
            event_category: 'FicheProduit',
            event_action: this.toggle[arg] ? 'Clic_derouler_infos' : 'Clic_reduire_infos',
            event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
          }
        });
      }

      if (arg === 'additional') {
        this.$root.$emit('generic-tracking', event, {
          fn: 'track-event',
          data: {
            event_category: 'FicheProduit',
            event_action: 'Clic_sheesham',
            event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
          }
        });
      }

      if (arg === 'range') {
        this.$root.$emit('generic-tracking', event, {
          fn: 'track-event',
          data: {
            event_category: 'FicheProduit',
            event_action: 'Clic_gamme',
            event_label: this.payload.line
          }
        });
      }
    }
  }
};